export const MAIN_BANNER_TEST_IDS = {
  // ─── Banner Section ───
  sectionContainer: 'main-banner-section-container',

  // ─── CTA Banner (Main) ───
  ctaBanner: 'main-banner-cta-banner',
  ctaBannerDesktopImage: 'main-banner-cta-desktop-image',
  ctaBannerMobileImage: 'main-banner-cta-mobile-image',

  // ─── Background Image Cards ───
  cardLeft: 'main-banner-card-left',
  cardLeftImage: 'main-banner-card-left-image',
  cardLeftTitle: 'main-banner-card-left-title',
  cardLeftSubtitle: 'main-banner-card-left-subtitle',
  cardLeftButton: 'main-banner-card-left-btn',

  cardRight: 'main-banner-card-right',
  cardRightImage: 'main-banner-card-right-image',
  cardRightTitle: 'main-banner-card-right-title',
  cardRightSubtitle: 'main-banner-card-right-subtitle',
  cardRightButton: 'main-banner-card-right-btn',
} as const;
